import React, { FC, PropsWithChildren } from 'react';
import CloseModalButton from '../CloseModalButton';

type Props = {
  title?: string;
  hasCloseButton?: boolean;
  hide?: () => void;
};

// Inspired by https://upmostly.com/tutorials/modal-components-react-custom-hooks
const ModalWithTitleInner: FC<Props & PropsWithChildren> = (props) => {
  return (
    <>
      {props.hasCloseButton && props.hide && (
        <CloseModalButton handleClick={props.hide} />
      )}
      {props.title && (
        <div className="flex justify-center p-4 text-[20px] font-semibold border-b-2 border-gray-200">
          {props.title}
        </div>
      )}
      <div className="flex flex-col px-2 tablet:px-8 py-8">
        {props.children}
      </div>
    </>
  );
};

export default ModalWithTitleInner;
